import { createNamespacedHelpers } from 'vuex';
const { mapGetters: reconciliationGetters, mapMutations: reconciliationMutations } =
    createNamespacedHelpers('reconciliationStore');

export default {
    data() {
        return {
            isCollapsed: true,

            paymentsToAdd: [],
            numberFormat: {
                precision: parseInt(App.numformat.precision),
                decimal: App.numformat.decimals,
                thousand: App.numformat.thousands,
            },
            payTypes: [
                {
                    id: 'credit',
                    value: this.$l10n.__('Crédit'),
                },
                {
                    id: 'debit',
                    value: this.$l10n.__('Débit'),
                },
            ],
        };
    },
    computed: {
        ...reconciliationGetters([
            'reconciled',
            'transactionType',
            'transactionRemainingReconciledAmount',
            'transactionDate',
        ]),
        wordingBtnCollapse: function () {
            if (this.isCollapsed) {
                return this.$l10n.__('Afficher les règlements déjà rapprochés');
            }

            return this.$l10n.__('Masquer les règlements déjà rapprochés');
        },
        hasReconciledPayment: function () {
            for (let index = 0; index < this.payments.length; index++) {
                const payment = this.payments[index];
                if (payment.isReconciled) {
                    return true;
                }
            }
            return false;
        },
        canAddPayment: function () {
            const newPayment = this.reconciled.filter((reconciled) => {
                if (
                    reconciled.document.id === this.document.id &&
                    reconciled.paymentid === undefined
                ) {
                    return true;
                }
                return false;
            });

            // Can't add more than two new payment
            if (newPayment.length > 0) {
                return false;
            }
            if (this.paymentsToAdd.length > 0) {
                return false;
            }
            if (this.dueAmount == 0) {
                return false;
            }
            if (this.document.step !== 'paid') {
                return true;
            }
            return false;
        },
        paymentsToDisplay: function () {
            // Payment list given to the component, from DB
            let payments = this.payments || [];
            if (this.isCollapsed) {
                payments = payments.filter((payment) => {
                    return payment.isReconciled === false;
                });
            }

            // Payments added during current reconciliation, from Store
            let newPayment = (this.reconciled || []).filter((reconciled) => {
                return (
                    reconciled.document.id === this.document.id &&
                    reconciled.paymentid === undefined
                );
            });
            newPayment = newPayment.map((payment) => {
                payment.isChecked = true;
                payment.storeId = payment.id;
                return payment;
            });

            const newPaymentRows = newPayment.map((p) => ({
                ...p,
                isChecked: true,
                storeId: p.id,
            }));

            // Merge
            const merged = payments.map((p) => {
                const reconciled = (this.reconciled || []).find((r) => {
                    return r.document.id === this.document.id && r.paymentid === p.payid;
                });

                return {
                    ...p,
                    isChecked: p.isReconciled || reconciled !== undefined,
                    storeId: reconciled ? reconciled.id : undefined,
                };
            });
            return merged.concat(newPaymentRows);

        },
        dueAmount: function () {
            const newPaymentAmountsForCurrentDoc = this.reconciled
                .filter((reconciled) => {
                    if (
                        reconciled.document.id === this.document.id &&
                        reconciled.paymentid === undefined
                    ) {
                        return true;
                    }
                    return false;
                })
                .map((reconciled) => {
                    if (reconciled.sens == 'positive') return reconciled.amount * -1;
                    else return reconciled.amount;
                });
            return (
                this.document.dueAmount -
                newPaymentAmountsForCurrentDoc.reduce(
                    (accumulator, currentValue) =>
                        parseFloat(accumulator) + parseFloat(currentValue),
                    0,
                )
            );
        },
        defaultNewPayment: function () {
            const reconciledPaymentAmounts = this.reconciled.map((reconciled) => {
                return reconciled.amount;
            });
            const transactionRemainingReconciledAmount =
                this.transactionRemainingReconciledAmount -
                reconciledPaymentAmounts.reduce(
                    (accumulator, currentValue) =>
                        parseFloat(accumulator) + parseFloat(currentValue),
                    0,
                );

            if (transactionRemainingReconciledAmount < this.dueAmount) {
                return transactionRemainingReconciledAmount;
            }
            return this.dueAmount;
        },
        isSaleDoc: function () {
            const saleDocs = ['invoice', 'creditnote'];
            return saleDocs.includes(this.document.type);
        },
    },
    methods: {
        // Tools
        ...reconciliationMutations(['addReconciled', 'delReconciled']),
        rowKey: function (row) {
            return this.document.id + '-' + row.payid + '-' + row.storeId;
        },
        rowKeyNewPayment: function (row) {
            return row.id;
        },
        getDefaultPayType() {
            return this.transactionType;
        },

        // Events

        togglePaymentsDisplay: function () {
            this.isCollapsed = !this.isCollapsed;
        },
        removeSelectedLine: function () {
            this.paymentsToAdd = [];
        },
    },
};
